<div class="filter-container" [ngClass]="!isCardView ? 'border-bottom' : null">
  <!-- Tablet view hamburg -->
  <button id="tablet-menu" type="button" class="button secondary__button squre__btn tablet-menu-btn"
          (click)="toggleLeftMenu()">
    <em class="fa fa-bars font-size-20"></em>
  </button>

  <div class="filter-options">
    <div class="sort-by-container">
      <dashboard-custom-select #reportSummarySort="ngModel" id="sortBy" [(ngModel)]="reportSummary.sort"
                               [values]="sortByList" placeholder="Choose Business Entity Type"
                               (ngModelChange)="changeSortBy()"
                               [innerValue]="reportSummary.sort" floatingLabel="Sort by"
                               name="reportSummarySort"></dashboard-custom-select>
    </div>
    <div class="reports-filter">
      <dashboard-custom-select #reportSummaryMode="ngModel" id="reportMode" [(ngModel)]="reportSummary.MODE"
                               [values]="reportModeList" placeholder="Choose Business Entity Type"
                               (ngModelChange)="changeShowMode()"
                               [innerValue]="reportSummary.MODE" floatingLabel="Show"
                               name="reportSummaryMode"></dashboard-custom-select>
    </div>
  </div>

  <div class="flex-grow-1">
    <div class="position-relative">
      <em class="fa fa-search input__icon input__icon--large"></em>
      <input id="dashboard-report-report-search" autocomplete="off" #searchInput type="text"
             class="input search-input input__wrap--icon input__large" [(ngModel)]="reportSummary.QUERY"
             placeholder="Search...">
    </div>
  </div>

  <div class="change-view">
    <button type="button" id="dashboard-card-view"
            [ngClass]="{'button secondary__button medium__button': isCardView, 'btn color--blue border-0 toggle-button--group': !isCardView}"
            (click)="btnCard()"><em class="fa fa-th-large font-size-20"></em></button>
    <button type="button" id="dashboard-card-list"
            [ngClass]="{'button secondary__button medium__button': !isCardView, 'btn color--blue border-0 toggle-button--group': isCardView}"
            (click)="btnList()"><em class="fa fa-bars font-size-20"></em></button>
  </div>

  <div class="dashboard__header">
    <!-- Report Checklist -->
    <a id="dashboard-download-checkList" role="button" class="button white__button squre__btn report-checklist-btn"
       (click)="downloadChecklist()" [popover]="'Report Checklist'" triggers="mouseenter:mouseleave" placement="bottom">
      <svg-icon name="report-checklist"></svg-icon>
    </a>

    <!-- Express Valuation -->
    <button id="dashboard-quick-report" type="button" class="button secondary__button squre__btn qr__btn express-valuation-btn"
            (click)="createQuickReport()">
      <svg-icon name="thunderstorm"></svg-icon>
      <span class="label-hidden">EXPRESS VALUATION</span>
    </button>

    <!-- Create Report -->
    <button id="dashboard-create-report" type="button" class="button primary__button w-100 cr__btn create-report-button"
            (click)="createNewReport()">
      <span class="label-hidden-cr">CREATE REPORT</span>
      <em class="fa fa-plus ml-2"></em>
    </button>

    <!-- Tablet + Mobile view menu -->
    <div class="menu-container">
      <!-- Overlay when menu is open -->
      <div class="overlay" *ngIf="isSideMenuOpen" (click)="toggleLeftMenu()"></div>

      <!-- Sidebar Menu -->
      <div class="side-menu" [@slideInOut]="isSideMenuOpen ? 'open' : 'closed'">
        <div class="mobile-filter-header">
          <span class="header-text">Filter options</span>
          <button type="button" class="close-btn" (click)="toggleLeftMenu()">✖</button>
        </div>
        <div class="filter-options">
          <div class="sort-by-container">
            <dashboard-custom-select #reportSummarySort="ngModel" id="sortByTablet" [(ngModel)]="reportSummary.sort"
                                     [values]="sortByList" placeholder="Choose Business Entity Type"
                                     (ngModelChange)="changeSortBy();toggleLeftMenu();"
                                     [innerValue]="reportSummary.sort" floatingLabel="Sort by"
                                     name="reportSummarySort"></dashboard-custom-select>
          </div>
          <div class="reports-filter">
            <dashboard-custom-select #reportSummaryMode="ngModel" id="reportModeTablet" [(ngModel)]="reportSummary.MODE"
                                     [values]="reportModeList" placeholder="Choose Business Entity Type"
                                     (ngModelChange)="changeShowMode();toggleLeftMenu();"
                                     [innerValue]="reportSummary.MODE" floatingLabel="Show"
                                     name="reportSummaryMode"></dashboard-custom-select>
          </div>
        </div>
        <div class="side-menu-action-button">
          <button id="tablet-report-checklist" type="button" class="button secondary__button squre__btn"
                  (click)="downloadChecklist();toggleLeftMenu();">
            <svg-icon name="report-checklist" [svgClass]="'mr-2'"></svg-icon>
            <span class="label-hidden">Report Checklist</span>
          </button>
        </div>
        <div class="side-menu-action-button">
          <button id="tablet-quick-report" type="button" class="button secondary__button squre__btn"
                  (click)="createQuickReport();toggleLeftMenu();">
            <svg-icon name="thunderstorm"></svg-icon>
            <span class="label-hidden">EXPRESS VALUATION</span>
          </button>
        </div>
        <div class="tablet-change-view" *ngIf="!common.isMobileDevice">
          <button type="button" id="tablet-dashboard-card-view"
                  [ngClass]="{'button secondary__button medium__button': isCardView, 'btn color--blue border-0 toggle-button--group': !isCardView}"
                  (click)="btnCard();toggleLeftMenu();">
            <em class="fa fa-th-large font-size-20 mr-2"></em> Grid
          </button>
          <button type="button" id="tablet-dashboard-card-list"
                  [ngClass]="{'button secondary__button medium__button': !isCardView, 'btn color--blue border-0 toggle-button--group': isCardView}"
                  (click)="btnList();toggleLeftMenu();">
            <em class="fa fa-bars font-size-20 mr-2"></em> List
          </button>
        </div>
      </div>
    </div>

    <!-- <div class="btn-group" dropdown placement="bottom right">
      <button id="button-split" type="button" dropdownToggle
        class="button primary__button opt__btn dropdown-toggle dropdown-toggle-split" aria-controls="dropdown-split">
        <span class="caret"></span>
      </button>
      <ul id="dropdown-split" *dropdownMenu
        class="dropdown__container dropdown-menu dropdown-menu-right dropdown__action" role="menu"
        aria-labelledby="button-split">
        <li role="menuitem" (click)="createNewReport()"><a class="dropdown-item">Create Report</a></li>
        <li class="divider dropdown-divider"></li>
        <li role="menuitem" (click)="openCompanySelectionPopup()"><a class="dropdown-item">Create Quickbooks Report</a>
        </li>
      </ul>
    </div> -->

  </div>
</div>

<!-- Loading Skeleton -->
<ng-container *ngIf="isLoading">
  <app-dashboard-loading-skeleton [loading]="isLoading"></app-dashboard-loading-skeleton>
</ng-container>

<ng-container *ngIf="!isLoading">
  <!-- Card View -->
  <div class="row grid-container" *ngIf="isCardView">
    <div class="card-view" [class.isLocked]="rpt.IS_LOCKED" *ngFor="let rpt of reportList; let i = index;">

      <ng-template #preparedCardTemplate>The report prepared for <strong>{{rpt.PREPARED_FOR_ENTITY}}</strong> changed to
        <strong>{{userService.getUserFullName()}}</strong>
      </ng-template>
      <div class="prepared__for__tag" *ngIf="rpt.PREPARED_FOR_ENTITY" [popover]="preparedCardTemplate"
           triggers="mouseenter:mouseleave" placement="bottom right"></div>

      <div class="company-name">
        <div class="company-header">
          <h5 class="name mb-0" (click)="!rpt.IS_LOCKED ? editReport(rpt) : null" disabled
              [style.width]="rpt.FINAL_VALUE ? '80%' : '60%'">
            <span *ngIf="rpt.COMPANY_NAME" [popover]="rpt.COMPANY_NAME?.length > 20 ? rpt.COMPANY_NAME : ''"
                  triggers="mouseenter:mouseleave" placement="bottom left">{{rpt.COMPANY_NAME}}</span>
            <span class="color--light--gray" *ngIf="!rpt.COMPANY_NAME">No Company Name</span>
          </h5>
          <div class="final-value">
            <div class="mb-0 label">Final Value</div>
            <div class="no-value" *ngIf="rpt.COMPLETION == 100 && rpt.STATE == reportStateEnum.CREATED">Awaiting for
              Payment
            </div>
            <div class="value" *ngIf="rpt.COMPLETION == 100 && rpt.STATE != reportStateEnum.CREATED">${{rpt.FINAL_VALUE
              | number}}</div>
            <div class="no-value" *ngIf="rpt.COMPLETION != 100 && !rpt.FINAL_VALUE">Not Valued</div>
          </div>
        </div>
      </div>

      <div class="mt-2">
        <div class="progress-container mb-0" [ngClass]="rpt.COMPLETION == 100 ? 'completed' : 'active'">
          <div class="progress w-100 progress-item">
            <div class="progress-bar" role="progressbar" [style.width]="rpt.COMPLETION + '%'" aria-valuemin="0"
                 aria-valuemax="100"></div>
          </div>
          <div class="percentage" [style.left]="getProgressPercentageLeftPosition(rpt.COMPLETION)">
            {{rpt.COMPLETION || 0}}%
          </div>
        </div>
      </div>

      <div class="detail">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="label">Company DBA</div>
            <div class="value value__hover" *ngIf="rpt.DBA" [popover]="rpt.DBA?.length > 25 ? rpt.DBA : ''"
                 triggers="mouseenter:mouseleave" placement="bottom left">
              {{rpt.DBA}}
            </div>
            <div class="no-value" *ngIf="!rpt.DBA">No DBA</div>
          </div>
          <div class="col-md-6">
            <div class="label">Status</div>
            <div class="value" *ngIf="rpt.STATE">
              <span class="value__hover" *ngIf="rpt.STATE != reportStateEnum.UNLOCKED">
                {{reportService.changeTextStyle(rpt.STATE)}}
              </span>
              <span *ngIf="rpt.STATE == reportStateEnum.UNLOCKED">
                <span class="color-secondary-gray value__hover">Expires on </span> <span
                class="color--blue">{{rpt.UNLOCKED_EXP}}</span>
              </span>
            </div>
            <div class="no-value" *ngIf="!rpt.STATE">-</div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6" *ngIf="rpt.EFFECTIVE_DATE">
            <div class="label">Effective Date</div>
            <div class="value value__hover">{{rpt.EFFECTIVE_DATE | date: 'dd MMM yyyy'}}</div>
          </div>
          <div class="col-md-6" *ngIf="!rpt.EFFECTIVE_DATE">
            <div class="label">Valuation Date</div>
            <div class="value value__hover" *ngIf="rpt.VALUATION_DATE">{{rpt.VALUATION_DATE | date: 'dd MMM yyyy'}}
            </div>
            <div class="no-value" *ngIf="!rpt.VALUATION_DATE">No Valuation Date</div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-12">
            <ng-container *ngIf="rpt.STATE != reportStateEnum.NON_BILLABLE">
              <div class="label">Payment Status</div>
              <div class="value"
                   [ngClass]="{'color--blue': rpt.STATE === reportStateEnum.LOCKED, 'color--green2__imp': rpt.STATE === reportStateEnum.UNLOCKED, 'color--red__imp': rpt.STATE === reportStateEnum.CREATED}">
                {{getReportState(rpt.STATE, rpt.COMPLETION)}}</div>
            </ng-container>
            <ng-container *ngIf="rpt.STATE === reportStateEnum.NON_BILLABLE">
              <div class="label">&nbsp;</div>
              <div class="value">
                &nbsp;
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 col-sm-6 pt-2">
          <ng-container *ngIf="rpt.ORG_SHARED == shareStatusEnum.SHARED && !rpt.IS_LOCKED">
            <div class="button secondary__button medium__button squre__btn">
              <img src="../../../assets/images/shared-org-icon.svg" alt="Org Shared">
            </div>
          </ng-container>
          <ng-container *ngIf="!rpt.IS_LOCKED && rpt.ORG_SHARED != shareStatusEnum.SHARED && rpt.TOP_SHARES?.length">
            <ng-container *ngFor="let user of rpt.TOP_SHARES; let i = index;">
              <img [src]="user.THUMBNAIL_IMAGE" onerror="this.src='../../../assets/images/profilePhoto.jpg';"
                   class="rounded-circle rounded-border position-absolute" width="32" [style.margin-left]="18 * i+'px'">
            </ng-container>
            <div class="rounded-circle rounded-border img-thumbnail image-count position-relative"
                 style="margin-left: 54px;" *ngIf="rpt.SHARED_COUNT > 3">
              <span class="value">+{{rpt.SHARED_COUNT - 3}}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="rpt.IS_LOCKED">
            <div
              [popover]="rpt.LOCKING_USER_NAME ? 'This report is currently being edited by ' + rpt.LOCKING_USER_NAME : ''"
              triggers="mouseenter:mouseleave" placement="top left">
              <img [src]="rpt.LOCKING_USER_THUMBNAIL" onerror="this.src='../../../assets/images/profilePhoto.jpg';"
                   class="rounded-circle rounded-border" width="32">
              <span class="editing__info">
                <img src="../../../assets/images/pencil-icon.svg" alt="...">
                Editing
              </span>
            </div>
          </ng-container>
        </div>
        <div class="col-md-8 col-sm-6 text-right">
          <span class="mr-2">
            <button id="{{'dashboard-open-note-modal-'+i}}" type="button" class="btn note__btn rounded bg-white"
                    (click)="openShowNoteModal(rpt)" [disabled]="!rpt.NOTES_COUNT || rpt.IS_LOCKED">
              <em class="fa fa-file-o color--blue"></em>
              <sup><span class="badge badge-pill note-badge">{{rpt.NOTES_COUNT}}</span></sup>
            </button>
          </span>

          <span class="mr-2" *ngIf="false">
            <button class="button secondary__button medium__button px-2" [disabled]="rpt.IS_LOCKED">
              <img alt="..." src="../../../assets/images/qb-green-icon.png" width="25" class="mr-2">
              Connected
            </button>
          </span>

          <span *ngIf="!rpt.IS_LOCKED">
            <app-report-option [showTop]="((i+1) > 3) && ((reportList.length - 3) <= i)" [reportId]="rpt.REPORT_ID"
                               [isReportDone]="rpt.COMPLETION == 100 ? true : false" [reportName]="rpt.COMPANY_NAME"
                               [reportState]="rpt.STATE" [sharedWithOrg]="rpt.ORG_SHARED == shareStatusEnum.SHARED"
                               [reportVersionId]="rpt.REPORT_VERSION_ID" (reloadPage)="spliceReport(i)"
                               [preparedEntity]="rpt.PREPARED_FOR_ENTITY"
                               [preparedAddress]="rpt.PREPARED_FOR_ENTITY_ADDRESS"
                               [createdByUserId]="rpt.CREATED_BY" [maxStage]="rpt.MAX_STAGE"
                               [isShared]="rpt?.SHARE_STATUS == shareStatusEnum.SHARED || rpt?.ORG_SHARED == shareStatusEnum.SHARED">
            </app-report-option>
          </span>
          <span *ngIf="rpt.IS_LOCKED">
            <button type="button" class="button disabled__option__btn">
              <em class="fa fa-ellipsis-h font-size-21"></em>
            </button>
          </span>
        </div>
      </div>

    </div>
  </div>

  <!-- List View -->
  <ng-container *ngIf="!isCardView">
    <div class="row list-view" [class.isLocked]="rpt.IS_LOCKED" *ngFor="let rpt of reportList; let i = index;">

      <ng-template #preparedListTemplate>The report prepared for <strong>{{rpt.PREPARED_FOR_ENTITY}}</strong> changed to
        <strong>{{userService.getUserFullName()}}</strong>
      </ng-template>
      <div class="prepared__for__tag" *ngIf="rpt.PREPARED_FOR_ENTITY" [popover]="preparedListTemplate"
           triggers="mouseenter:mouseleave" placement="bottom right"></div>

      <div class="col-lg-4 col-md-12">
        <div class="row mb-3 align-items-end">
          <!-- <h5 class="col-md-7 font-weight-bold mb-0" role="button" (click)="editReport(rpt)">
          {{rpt.COMPANY_NAME}}
        </h5>
        <span class="color--light--gray" *ngIf="!rpt.COMPANY_NAME">No Company Name</span> -->

          <h5 class="col-md-7 font-weight-bold mb-0 ellipsis" role="button" (click)="editReport(rpt)" [popover]="rpt.COMPANY_NAME?.length > 20 ? rpt.COMPANY_NAME : ''"
            triggers="mouseenter:mouseleave" placement="bottom left">
            <span *ngIf="rpt.COMPANY_NAME">{{rpt.COMPANY_NAME}}</span>
            <span class="color--light--gray" *ngIf="!rpt.COMPANY_NAME">No Company Name</span>
          </h5>

          <div class="col-md-5 detail">
            <div class="label mb-0">Final Value</div>
            <div class="value color--gray--2--imp font-size-16__imp"
                 *ngIf="rpt.COMPLETION == 100 && rpt.STATE == reportStateEnum.CREATED">Awaiting for Payment
            </div>
            <div class="value" *ngIf="rpt.COMPLETION == 100 && rpt.STATE != reportStateEnum.CREATED">${{rpt.FINAL_VALUE
              | number}}</div>
            <div class="no-value" *ngIf="rpt.COMPLETION != 100 && !rpt.FINAL_VALUE">Not Valued</div>
          </div>
        </div>
        <div>
          <div class="dashboard-progress-container handle-spacing mb-0"
               [ngClass]="rpt.COMPLETION == 100 ? 'completed' : 'active'">
            <div class="progress w-100 dashboard-progress">
              <div class="progress-bar" role="progressbar" [style.width]="rpt.COMPLETION + '%'" aria-valuemin="0"
                   aria-valuemax="100">
              </div>
            </div>
            <div class="percentage"
                 [style.left]="rpt.COMPLETION > 90 ? (rpt.COMPLETION - 8)+ '%' : (rpt.COMPLETION)+ '%'">{{rpt.COMPLETION ||
            0}}%
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-8 detail">
        <div class="row mb-3">
          <div class="col-md-3">
            <div class="label">Company DBA</div>
            <div class="value" *ngIf="rpt.DBA" [popover]="rpt.DBA?.length > 25 ? rpt.DBA : ''"
                 triggers="mouseenter:mouseleave" placement="bottom left">{{rpt.DBA}}</div>
            <div class="no-value" *ngIf="!rpt.DBA">No DBA</div>
          </div>

          <!-- Status -->
          <div class="col-md-2">
            <div class="label">Status</div>
            <div class="value" *ngIf="rpt.STATE">
              <span *ngIf="rpt.STATE != reportStateEnum.UNLOCKED">
                {{reportService.changeTextStyle(rpt.STATE)}}
              </span>
              <span *ngIf="rpt.STATE == reportStateEnum.UNLOCKED">
                <span class="color-secondary-gray">Expires on </span> <br/> <span
                class="color--blue">{{rpt.UNLOCKED_EXP}}</span>
              </span>
            </div>
            <div class="no-value" *ngIf="!rpt.STATE">-</div>
          </div>

          <!-- Valuation Date -->
          <div class="col-md-3" *ngIf="rpt.EFFECTIVE_DATE">
            <div class="label">Effective Date</div>
            <div class="value value__hover">{{rpt.EFFECTIVE_DATE | date: 'dd MMM yyyy'}}</div>
          </div>
          <div class="col-md-3" *ngIf="!rpt.EFFECTIVE_DATE">
            <div class="label">Valuation Date</div>
            <div class="value" *ngIf="rpt.VALUATION_DATE">{{rpt.VALUATION_DATE | date: 'dd MMM yyyy'}}</div>
            <div class="no-value" *ngIf="!rpt.VALUATION_DATE">No Valuation Date</div>
          </div>

          <!-- Payment Status -->
          <div class="col-md-4" *ngIf="rpt.STATE != reportStateEnum.NON_BILLABLE">
            <div class="label">Payment Status</div>
            <div class="value"
                 [ngClass]="{'color--blue': rpt.STATE === reportStateEnum.LOCKED, 'color--green2__imp': rpt.STATE === reportStateEnum.UNLOCKED, 'color--red__imp': rpt.STATE === reportStateEnum.CREATED}">
              {{getReportState(rpt.STATE, rpt.COMPLETION)}}</div>
          </div>
        </div>
      </div>

      <div class="col-lg-2 col-md-4 handle-list-view-in-tablet">
        <div class="image-container">
          <ng-container *ngIf="rpt.ORG_SHARED == shareStatusEnum.SHARED && !rpt.IS_LOCKED">
            <div class="button secondary__button medium__button squre__btn">
              <img src="../../../assets/images/shared-org-icon.svg" alt="Org Shared">
            </div>
          </ng-container>
          <ng-container *ngIf="!rpt.IS_LOCKED && rpt.ORG_SHARED != shareStatusEnum.SHARED && rpt.TOP_SHARES?.length">
            <div class="rounded-circle rounded-border img-thumbnail position-absolute image-count"
                 style="right: 0px; z-index: 5" *ngIf="rpt.SHARED_COUNT > 3">
              <span class="value">+{{rpt.SHARED_COUNT - 3}}</span>
            </div>
            <ng-container *ngFor="let user of rpt.TOP_SHARES; let i = index;">
              <img [src]="user.THUMBNAIL_IMAGE" onerror="this.src='../../../assets/images/profilePhoto.jpg';"
                   class="rounded-circle rounded-border position-absolute" width="32" [style.right]="18 * (i + 1)+'px'"
                   [style.z-index]="4 - i">
            </ng-container>
          </ng-container>
          <ng-container *ngIf="rpt.IS_LOCKED">
            <div
              [popover]="rpt.LOCKING_USER_NAME ? 'This report is currently being edited by ' + rpt.LOCKING_USER_NAME : ''"
              triggers="mouseenter:mouseleave" placement="top left">
              <img [src]="rpt.LOCKING_USER_THUMBNAIL" onerror="this.src='../../../assets/images/profilePhoto.jpg';"
                   class="rounded-circle rounded-border" width="32">
              <span class="editing__info">
                <img src="../../../assets/images/pencil-icon.svg" alt="...">
                Editing
              </span>
            </div>
          </ng-container>
        </div>
        <div class="d-flex justify-content-end align-items-center">
          <div class="mr-2">
            <!-- <app-show-note-modal [noteCount]="rpt.noteCount" [companyName]="rpt.companyName"></app-show-note-modal> -->
            <button id="{{'dasbhoard-list-show-note-modal'+i}}" type="button"
                    class="btn rounded bg-white position-relative" (click)="openShowNoteModal(rpt)"
                    [disabled]="!rpt.NOTES_COUNT || rpt.IS_LOCKED">
              <em class="fa fa-file-o color--blue"></em>
              <sup><span class="badge badge-pill note-badge">{{rpt.NOTES_COUNT}}</span></sup>
            </button>
          </div>

          <ng-container *ngIf="!rpt.IS_LOCKED">
            <app-report-option [reportId]="rpt.REPORT_ID" [isReportDone]="rpt.COMPLETION == 100 ? true : false"
                               [reportName]="rpt.COMPANY_NAME"
                               [sharedWithOrg]="rpt.ORG_SHARED == shareStatusEnum.SHARED"
                               [reportVersionId]="rpt.REPORT_VERSION_ID" (reloadPage)="spliceReport(i)"
                               [reportState]="rpt.STATE"
                               [preparedEntity]="rpt.PREPARED_FOR_ENTITY"
                               [preparedAddress]="rpt.PREPARED_FOR_ENTITY_ADDRESS"
                               [createdByUserId]="rpt.CREATED_BY" [maxStage]="rpt.MAX_STAGE"
                               [isShared]="rpt?.SHARE_STATUS == shareStatusEnum.SHARED || rpt?.ORG_SHARED == shareStatusEnum.SHARED">
            </app-report-option>
          </ng-container>
          <ng-container *ngIf="rpt.IS_LOCKED">
            <button type="button" class="button disabled__option__btn">
              <em class="fa fa-ellipsis-h font-size-21"></em>
            </button>
          </ng-container>
        </div>

      </div>
    </div>
  </ng-container>

  <ng-container
    *ngIf="!reportList.length && (reportSummary.QUERY || reportSummary.MODE == reportModeEnum.SHARED_WITH_ME) && showBlankPage">
    <div class="no__record">
      <svg-icon name="sad-magnify-blue"></svg-icon>
      <div class="title my-4">No results found</div>
      <div class="desc">Sorry, we couldn’t find any results to your search criteria.</div>
    </div>
  </ng-container>
  <ng-container
    *ngIf="!reportList.length && !reportSummary.QUERY && showBlankPage && reportSummary.MODE != reportModeEnum.SHARED_WITH_ME">
    <div class="no__record">
      <svg-icon name="blue-plus-first-rpt"></svg-icon>
      <div class="title my-4">Create Your First Report</div>
      <div class="desc">
        <strong>Create a Free Express Valuation</strong> to obtain an approximate value of your business!
        <br>
        <br>
        If you would like to run a more detailed valuation report, <br/>
        please click on <strong>Create Report.</strong>
      </div>
      <button class="button large__button primary__button mt-3 adjust-button-width" (click)="createQuickReport()">
        Create a Free Express Valuation
      </button>
      <br>
      <button class="button large__button secondary__button mt-3 adjust-button-width" (click)="createNewReport()">
        Create Report
      </button>
    </div>
  </ng-container>
</ng-container>
